<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";

defineProps({
    classrooms: Array,
    //select_classroom: Array
    select_level: Array,
    select_modular_code: Array,
    param: Object
});
const rutaprefijo = ref('classroom');
const modulo = ref('Aula');
</script>

<template>

    <Head title="Aulas Configuración" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Aulas/Secciones" subtitle="Gestión de aulas/secciones">
        </PremiumPageHeader>
    </template>

        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->


                <CardBox has-table>
                    <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                    <TableSingle :modulo="modulo" :data="classrooms" :select1="select_level" :select2="select_modular_code" :ruta="rutaprefijo" :param="param" />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
